<script lang="ts" setup>
interface Props {
  pdfUrl?: string
  isOpen?: boolean
  target?: '_blank' | '_self'
}
const props = defineProps<Props>()

const emit = defineEmits<Emits>()
interface Emits {
  (e: 'close'): void
}
</script>

<template>
  <CommonDialog :opened="props.isOpen" @close="emit('close')">
    <template #title>
      {{ $t('pdf-confirmation-modal.title') }}
    </template>
    <template #content>
      <p class="whitespace-pre-line">
        {{ $t('pdf-confirmation-modal.header') }}
      </p>

      <ElementsButton
        class="mx-auto mt-6"
        :url="pdfUrl"
        :target="target ?? '_blank'"
        text-color="primary"
        @click="emit('close')"
      >
        {{ $t('pdf-confirmation-modal.show') }}
      </ElementsButton>
    </template>
  </CommonDialog>
</template>
